import { render, staticRenderFns } from "./ucusraporu.vue?vue&type=template&id=113086ff&"
import script from "./ucusraporu.vue?vue&type=script&lang=js&"
export * from "./ucusraporu.vue?vue&type=script&lang=js&"
import style0 from "./ucusraporu.vue?vue&type=style&index=0&id=113086ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports